
export default {
  props: {
    isExternal: {
      type: Boolean,
      default: false,
    },
    to: {
      type: String,
      default: null,
      required: true,
    },
    label: {
      type: String,
      default: null,
      required: true,
    },
    icon: {
      type: Object,
      default: null,
      required: true,
    },
    dataEventTracking: {
      type: String,
      default: null,
    },
  },
  computed: {
    isActive () {
      return this.$route.path === this.to
    },
  },

}
